module.exports = __webpack_public_path__ + "static/media/00.45e55999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-four/00.jpg
// module id = 147
// module chunks = 0